export default {
  allCategoriesTitle: {
    id: 'address_book_rules_all_categories_title',
    defaultMessage: 'Select all categories',
  },
  allCategoriesLabel: {
    id: 'address_book_rules_all_categories_label',
    defaultMessage: 'All categories',
  },
  allCategoriesDescription: {
    id: 'address_book_rules_all_categories_description',
    defaultMessage: 'All current and future categories',
  },
  someCategoriesTitle: {
    id: 'address_book_rules_some_categories_title',
    defaultMessage: 'or select categories one by one',
  },
  cta: {
    id: 'address_book_rules_cta',
    defaultMessage: 'Save and continue',
  },
}
